import React, { useState, useEffect, useContext } from "react";
import { queue$ } from '../../observables/queue';
import { useSubscribe } from '../../hooks';
import { QueueEventType, QueueActionType, QueueType } from '../../shared/types';
import { Modal, Checkbox } from '../../ui/components';
import { dirname, basename } from '../../utils/path';
import Path from '../Path/Path';
import styles from './QueueAction.less';
import { AppSettingsContext } from '../../context/config';
import numeral from 'numeral';
import { format } from 'date-fns';
export default function QueueAction() {
    const appSettings = useContext(AppSettingsContext);
    const [conflict, setConflict] = useState();
    const [conflicts, setConflicts] = useState([]);
    const [forAll, setForAll] = useState(false);
    const [remember, setRemember] = useState(false);
    useEffect(() => setRemember(false), [forAll]);
    useEffect(() => {
        setForAll(false);
        setRemember(false);
    }, [conflict]);
    const proceed = (id) => {
        if (conflict) {
            if (id == 'ok') {
                window.f5.resolve(conflict.id, { type: QueueActionType.Replace }, forAll, remember ? conflict.sid : undefined);
            }
            else if (id == 'cancel') {
                window.f5.resolve(conflict.id, { type: QueueActionType.Skip }, forAll, remember ? conflict.sid : undefined);
            }
            else {
                window.f5.stop(conflict.id);
            }
            conflicts.length ?
                setConflicts(conflicts => {
                    setConflict(conflicts[0]);
                    return conflicts.slice(1);
                }) :
                setConflict(undefined);
        }
    };
    useSubscribe(() => queue$.subscribe(({ id, event }) => {
        if (event.type == QueueEventType.Ask) {
            conflict ?
                setConflicts(conflicts => [...conflicts, { id, ...event }]) :
                setConflict({ id, ...event });
        }
    }));
    return React.createElement(React.Fragment, null, conflict &&
        React.createElement(Modal, { onClose: proceed, buttons: [{ id: 'stop', label: 'Stop' }, { id: 'cancel', label: 'Skip' }, { id: 'ok', label: 'Replace' }] },
            React.createElement("div", { className: 'modal-content ' + styles.root },
                React.createElement("header", null, "Choose action"),
                React.createElement("p", null,
                    "The destination already contains a ",
                    conflict.to.dir ? 'folder' : 'file',
                    " called",
                    React.createElement("strong", null, basename(conflict.to.path))),
                React.createElement("p", null,
                    "Would you like to replace the existing ",
                    conflict.to.dir ? 'folder' : 'file',
                    " in",
                    React.createElement("strong", null,
                        React.createElement(Path, { path: dirname(conflict.to.path) }))),
                React.createElement("div", { className: styles.file },
                    React.createElement("i", { className: 'icon' }, (conflict.queueType == QueueType.Move || conflict.queueType == QueueType.Copy) ?
                        (conflict.to.dir ? 'folder' : 'file_copy') :
                        (conflict.queueType == QueueType.Download ? 'computer' : 'cloud')),
                    React.createElement("p", null,
                        conflict.to.dir ? '' : React.createElement(React.Fragment, null,
                            'Size: ' + numeral(conflict.to.size).format('0.0 b'),
                            " ",
                            React.createElement("br", null)),
                        "Modified: ",
                        format(conflict?.to.modified, appSettings.timeFmt))),
                React.createElement("p", null,
                    "with the new one from",
                    React.createElement("strong", null,
                        React.createElement(Path, { path: dirname(conflict.from.path) }))),
                React.createElement("div", { className: styles.file },
                    React.createElement("i", { className: 'icon' }, (conflict.queueType == QueueType.Move || conflict.queueType == QueueType.Copy) ?
                        (conflict.from.dir ? 'folder' : 'file_copy') :
                        (conflict.queueType == QueueType.Download ? 'cloud' : 'computer')),
                    React.createElement("p", null,
                        conflict.to.dir ? '' : React.createElement(React.Fragment, null,
                            'Size: ' + numeral(conflict.from.size).format('0.0 b'),
                            " ",
                            React.createElement("br", null)),
                        "Modified: ",
                        format(conflict?.from.modified, appSettings.timeFmt))),
                React.createElement("div", { className: styles.checks },
                    React.createElement(Checkbox, { value: forAll, onChange: () => setForAll(v => !v) }, "Apply the chosen action to the rest of files"),
                    conflict.sid && forAll &&
                        React.createElement(Checkbox, { value: remember, onChange: () => setRemember(remember => !remember) }, "Remember for the current session")))));
}
